import { Component, ChangeDetectionStrategy } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'ocasa-cdd';
  ngOnInit() {
    const version = localStorage.getItem('version');
    if (environment.version !== version || version === 'null' || version === 'undefined' || version === '') {
      localStorage.setItem('version', environment.version);
      location.reload();
    }
  }
}